import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsx, jsxs } from 'react/jsx-runtime.js';
import cn from 'classnames';
import { useContext } from 'react';
import { isDark, getCurrentThemeColor } from '../../utils/theme.js';
import { ThemeContext } from '../ThemeContext.js';
import { ReactComponent as SvgQd } from '../../media/images/QD.svg.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import typographyStyles from '../Typography/Typography.module.css.js';
import styles from './Header.module.css.js';
import { ThemeToggle } from './ThemeToggle/ThemeToggle.js';
import { HeaderSubmenu } from './HeaderSubmenu.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Header(props) {
  var className = props.className,
    clickableLogo = props.clickableLogo,
    logoHtmlProps = props.logoHtmlProps,
    themeToggleHtmlProps = props.themeToggleHtmlProps,
    userControls = props.userControls,
    _props$menuItems = props.menuItems,
    menuItems = _props$menuItems === void 0 ? [] : _props$menuItems;
  var _useContext = useContext(ThemeContext),
    theme = _useContext.theme,
    systemTheme = _useContext.systemTheme,
    onThemeChange = _useContext.onThemeChange;
  var isDarkTheme = isDark(getCurrentThemeColor(theme, systemTheme));
  var logo = jsx(SvgQd, _objectSpread({}, logoHtmlProps));
  return jsxs("header", {
    className: cn(styles.header, className),
    children: [clickableLogo ? jsx("a", {
      href: "/",
      "aria-label": "go to root page",
      children: logo
    }) : jsx("h1", {
      className: styles.pageHeading,
      title: "Qodana",
      children: logo
    }), menuItems.length > 0 && jsx("div", {
      className: styles.menuItems,
      children: menuItems.map(function (item) {
        return item.type !== 'submenu' ? jsx("button", {
          className: cn(typographyStyles.text, styles.menuItem, styles.rootMenuItem),
          onClick: item.click,
          disabled: item.enabled === false,
          children: item.label
        }, item.id || item.label) : jsx(HeaderSubmenu, {
          submenuClassName: styles.rootMenuItem,
          className: styles.menuItem,
          item: item
        }, item.id || item.label);
      })
    }), jsxs("div", {
      className: styles.controls,
      children: [!!onThemeChange && jsx(ThemeToggle, {
        defaultChecked: isDarkTheme,
        htmlProps: themeToggleHtmlProps,
        onChange: onThemeChange
      }), userControls]
    })]
  });
}

export { Header };
